export default __webpack_public_path__ + "static/media/background-login-bottom.0ce578eb.svg";